export const START_LOADING = "start_loading";
export const END_LOADING = "end_loading";

export var startLoading = () => {
    return {
        type: START_LOADING
    };
};
export var endLoading = () => {
    return {
        type: END_LOADING
    };
};


// WEBPACK FOOTER //
// ./resources/assets/js/actions/loadingActions.js